import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
/**
 * `Service` The PackagesList service
 */
var PackagesList = /*#__PURE__*/function (_Base) {
  /**
   * Create the packages list service instance.
   *
   * @param sdk - the SDK instance
   */
  function PackagesList(sdk) {
    _classCallCheck(this, PackagesList);
    return _callSuper(this, PackagesList, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(PackagesList, _Base);
  return _createClass(PackagesList, [{
    key: "getPackages",
    value: (
    /**
     * Get packages list
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/9e0cb257cb228-list-packages
     *
     * @param projectId -  the project uuid
     * @param params - includes \{ limit, offset, sort, searchText, filter[*] \}
     * @param config - object for overwrite request parameters
     * @returns promise with shape of \{ pagination, results \}
     */
    function () {
      var _getPackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/packages").concat(query);
              _context.next = 4;
              return this.HttpService.pkgV1.get(url, config);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getPackages(_x, _x2, _x3) {
        return _getPackages.apply(this, arguments);
      }
      return getPackages;
    }()
    /**
     * Batch get packages
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/008fc75bc9fe0-batch-get-packages
     *
     * @param projectId -  the project uuid
     * @param packageIds - uuid list of the packages
     * @param config - object for overwrite request parameters
     * @returns promise with shape of \{ results \}
     */
    )
  }, {
    key: "batchGetPackages",
    value: (function () {
      var _batchGetPackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, packageIds, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages:batch-get");
              _context2.next = 3;
              return this.HttpService.pkgV1.post(url, packageIds, config);
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function batchGetPackages(_x4, _x5, _x6) {
        return _batchGetPackages.apply(this, arguments);
      }
      return batchGetPackages;
    }()
    /**
     * Create package
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages/post
     *
     * @param projectId -  the project uuid
     * @param pkg - object of \{ name, description \}
     * @param config - object for overwrite request parameters
     * @returns promise with package shape \{name, seqId, ...\}
     */
    )
  }, {
    key: "createPackage",
    value: (function () {
      var _createPackage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, pkg, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages");
              _context3.next = 3;
              return this.HttpService.pkgV1.post(url, pkg, config);
            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createPackage(_x7, _x8, _x9) {
        return _createPackage.apply(this, arguments);
      }
      return createPackage;
    }()
    /**
     * Edit package
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages:batch-update/post
     *
     * @param projectId -  the project uuid
     * @param pkg - object of \{ name, description \}
     * @param config - object for overwrite request parameters
     * @returns promise with package shape \{name, seqId, ...\}
     */
    )
  }, {
    key: "updatePackages",
    value: (function () {
      var _updatePackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, pkg, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages:batch-update");
              _context4.next = 3;
              return this.HttpService.pkgV1.post(url, pkg, config);
            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updatePackages(_x10, _x11, _x12) {
        return _updatePackages.apply(this, arguments);
      }
      return updatePackages;
    }()
    /**
     * Delete packages in batch
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages:batch-delete/post
     *
     * @param projectId -  the project uuid
     * @param packages - array of packages to be deleted
     * @param config - object for overwrite request parameters
     * @returns promise with shape of [\{id\}, ...]
     */
    )
  }, {
    key: "deletePackages",
    value: (function () {
      var _deletePackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, packages, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages:batch-delete");
              _context5.next = 3;
              return this.HttpService.pkgV1.post(url, packages, config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deletePackages(_x13, _x14, _x15) {
        return _deletePackages.apply(this, arguments);
      }
      return deletePackages;
    }()
    /**
     * Lock packages in batch
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages:batch-lock/post
     *
     * @param projectId -  the project uuid
     * @param packages - array of packages to be locked
     * @param config - object for overwrite request parameters
     * @returns promise with shape of [\{id\}, ...]
     */
    )
  }, {
    key: "lockPackages",
    value: (function () {
      var _lockPackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, packages, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages:batch-lock");
              _context6.next = 3;
              return this.HttpService.pkgV1.post(url, packages, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function lockPackages(_x16, _x17, _x18) {
        return _lockPackages.apply(this, arguments);
      }
      return lockPackages;
    }()
    /**
     * Unlock packages in batch
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages:batch-unlock/post
     *
     * @param projectId -  the project uuid
     * @param packages - array of packages to be unlocked
     * @param config - object for overwrite request parameters
     * @returns promise with shape of [\{id\}, ...]
     */
    )
  }, {
    key: "unlockPackages",
    value: (function () {
      var _unlockPackages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, packages, config) {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages:batch-unlock");
              _context7.next = 3;
              return this.HttpService.pkgV1.post(url, packages, config);
            case 3:
              res = _context7.sent;
              return _context7.abrupt("return", res.data);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function unlockPackages(_x19, _x20, _x21) {
        return _unlockPackages.apply(this, arguments);
      }
      return unlockPackages;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'PackagesList';
    }
  }]);
}(Base);
export default PackagesList;